// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/user.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreatePersonalAccessTokenRequest, CreatePersonalAccessTokenResponse, DeletePersonalAccessTokenRequest, DeletePersonalAccessTokenResponse, DeletePreferenceRequest, DeletePreferenceResponse, GetAuthenticatedUserRequest, GetAuthenticatedUserResponse, GetDotfilesConfigurationRequest, GetDotfilesConfigurationResponse, GetPersonalAccessTokenRequest, GetPersonalAccessTokenResponse, GetPreferenceRequest, GetPreferenceResponse, ListPersonalAccessTokensRequest, ListPersonalAccessTokensResponse, ListPreferencesRequest, ListPreferencesResponse, SetDotfilesConfigurationRequest, SetDotfilesConfigurationResponse, SetPreferenceRequest, SetPreferenceResponse, SetSuspendedRequest, SetSuspendedResponse } from "./user_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.UserService
 */
export const UserService = {
  typeName: "gitpod.v1.UserService",
  methods: {
    /**
     * Gets information about the currently authenticated user.
     *
     * Use this method to:
     * - Get user profile information
     * - Check authentication status
     * - Retrieve user settings
     * - Verify account details
     *
     * ### Examples
     *
     * - Get current user:
     *
     *   Retrieves details about the authenticated user.
     *
     *   ```yaml
     *   {}
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.GetAuthenticatedUser
     */
    getAuthenticatedUser: {
      name: "GetAuthenticatedUser",
      I: GetAuthenticatedUserRequest,
      O: GetAuthenticatedUserResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Sets whether a user account is suspended.
     *
     * Use this method to:
     * - Suspend problematic users
     * - Reactivate suspended accounts
     * - Manage user access
     *
     * ### Examples
     *
     * - Suspend user:
     *
     *   Suspends a user account.
     *
     *   ```yaml
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   suspended: true
     *   ```
     *
     * - Reactivate user:
     *
     *   Removes suspension from a user account.
     *
     *   ```yaml
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   suspended: false
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.SetSuspended
     */
    setSuspended: {
      name: "SetSuspended",
      I: SetSuspendedRequest,
      O: SetSuspendedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new personal access token for API authentication.
     *
     * Use this method to:
     * - Generate API access tokens
     * - Create service account credentials
     * - Set up automated access
     *
     * ### Examples
     *
     * - Create token:
     *
     *   Creates a new access token valid for 30 days.
     *
     *   ```yaml
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   description: "CI/CD Pipeline Token"
     *   validFor: "2592000s"  # 30 days
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.CreatePersonalAccessToken
     */
    createPersonalAccessToken: {
      name: "CreatePersonalAccessToken",
      I: CreatePersonalAccessTokenRequest,
      O: CreatePersonalAccessTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific personal access token.
     *
     * Use this method to:
     * - View token metadata
     * - Check token expiration
     * - Monitor token usage
     *
     * ### Examples
     *
     * - Get token details:
     *
     *   Retrieves information about a specific token.
     *
     *   ```yaml
     *   personalAccessTokenId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.GetPersonalAccessToken
     */
    getPersonalAccessToken: {
      name: "GetPersonalAccessToken",
      I: GetPersonalAccessTokenRequest,
      O: GetPersonalAccessTokenResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists personal access tokens with optional filtering.
     *
     * Use this method to:
     * - View all active tokens
     * - Audit token usage
     * - Manage token lifecycle
     *
     * ### Examples
     *
     * - List user tokens:
     *
     *   Shows all tokens for specific users.
     *
     *   ```yaml
     *   filter:
     *     userIds: ["f53d2330-3795-4c5d-a1f3-453121af9c60"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.ListPersonalAccessTokens
     */
    listPersonalAccessTokens: {
      name: "ListPersonalAccessTokens",
      I: ListPersonalAccessTokensRequest,
      O: ListPersonalAccessTokensResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes a personal access token.
     *
     * Use this method to:
     * - Revoke token access
     * - Remove unused tokens
     * - Rotate credentials
     *
     * ### Examples
     *
     * - Delete token:
     *
     *   Permanently revokes a token.
     *
     *   ```yaml
     *   personalAccessTokenId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.DeletePersonalAccessToken
     */
    deletePersonalAccessToken: {
      name: "DeletePersonalAccessToken",
      I: DeletePersonalAccessTokenRequest,
      O: DeletePersonalAccessTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets a user preference value.
     *
     * Use this method to:
     * - Store user settings
     * - Update preferences
     * - Configure user experience
     *
     * ### Examples
     *
     * - Set preference:
     *
     *   Updates a user preference setting.
     *
     *   ```yaml
     *   key: "theme"
     *   value: "dark"
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.SetPreference
     */
    setPreference: {
      name: "SetPreference",
      I: SetPreferenceRequest,
      O: SetPreferenceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets a specific user preference value.
     *
     * Use this method to:
     * - Retrieve user settings
     * - Read preference values
     * - Check configurations
     *
     * ### Examples
     *
     * - Get preference:
     *
     *   Retrieves a specific preference value.
     *
     *   ```yaml
     *   userPreferenceId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.GetPreference
     */
    getPreference: {
      name: "GetPreference",
      I: GetPreferenceRequest,
      O: GetPreferenceResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists all user preferences.
     *
     * Use this method to:
     * - View all user settings
     * - Export preferences
     * - Audit configurations
     *
     * ### Examples
     *
     * - List preferences:
     *
     *   Shows all preferences with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.ListPreferences
     */
    listPreferences: {
      name: "ListPreferences",
      I: ListPreferencesRequest,
      O: ListPreferencesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes a user preference.
     *
     * Use this method to:
     * - Remove settings
     * - Reset preferences
     * - Clean up configurations
     *
     * ### Examples
     *
     * - Delete preference:
     *
     *   Removes a specific preference.
     *
     *   ```yaml
     *   userPreferenceId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.DeletePreference
     */
    deletePreference: {
      name: "DeletePreference",
      I: DeletePreferenceRequest,
      O: DeletePreferenceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the dotfiles for a user.
     *
     * Use this method to:
     * - Retrieve user dotfiles
     *
     * ### Examples
     *
     * - Get dotfiles:
     *
     *   Retrieves the dotfiles for the current user.
     *
     *   ```yaml
     *   {}
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.GetDotfilesConfiguration
     */
    getDotfilesConfiguration: {
      name: "GetDotfilesConfiguration",
      I: GetDotfilesConfigurationRequest,
      O: GetDotfilesConfigurationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Sets the dotfiles configuration for a user.
     *
     * Use this method to:
     * - Configure user dotfiles
     * - Update dotfiles settings
     *
     * ### Examples
     *
     * - Set dotfiles configuration:
     *
     *   Sets the dotfiles configuration for the current user.
     *
     *   ```yaml
     *   {
     *     "repository": "https://github.com/gitpod-io/dotfiles",
     *   }
     *   ```
     *
     * - Remove dotfiles:
     *
     *   Removes the dotfiles for the current user.
     *
     *   ```yaml
     *   {}
     *   ```
     *
     * @generated from rpc gitpod.v1.UserService.SetDotfilesConfiguration
     */
    setDotfilesConfiguration: {
      name: "SetDotfilesConfiguration",
      I: SetDotfilesConfigurationRequest,
      O: SetDotfilesConfigurationResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

